import { Injectable } from '@angular/core';
import { ButtonItem } from '../../../../shared/button/button.model';
import { CoreServiceRegistry } from '../../../../core/core-service-registry';
import { SharedServiceRegistry } from '../../../../shared/shared-service-registry';
import { DetailedEntityButtonService } from '../../../../shared/services/searchable-entity/detailed-entity/detailed-entity-button.service';
import { ReportsConfigurationActionService } from './reports-configuration-action.service';

@Injectable()
export class ReportsConfigurationButtonService extends DetailedEntityButtonService {

  protected actionService: ReportsConfigurationActionService;

  constructor(coreServiceRegistry: CoreServiceRegistry,
    sharedServiceRegistry: SharedServiceRegistry) {
    super(coreServiceRegistry, sharedServiceRegistry);
  }

  protected getAllButtons(): any {
    return {
      'search-main': [
        new ButtonItem('Create', this.resourceService.get('lbl_create_new_PG'), 'report_conf_create', 'plus-circle', [])
      ],
      'detail-main': [
        new ButtonItem('Edit', this.resourceService.get('btn_edit'), 'report_conf_edit', 'pencil', []),
        new ButtonItem('Save', this.resourceService.get('btn_save'), '', 'floppy-disk', []),
        new ButtonItem('Delete', this.resourceService.get('btn_delete'), 'report_conf_delete', 'trash', []),
      ],
      'detail-table': [
        new ButtonItem('Add Row', this.resourceService.get('lbl_AddNewRow'), 'rpt_conf_dtl_add', 'plus-circle', []),
        new ButtonItem('Duplicate', this.resourceService.get('lbl_duplicate'), 'rpt_conf_dtl_dup', 'file-copy', []),
        new ButtonItem('Delete_Main', this.resourceService.get('btn_delete'), 'rpt_conf_dtl_delete', 'trash', [
          new ButtonItem('Delete Line Item(s)', this.resourceService.get('btn_delete_line'), 'rpt_conf_dtl_delete', 'trash', []),
          new ButtonItem('Delete All Line Items', this.resourceService.get('btn_delete_all_lines'), 'rpt_conf_dtl_delete', 'trash', []),
        ]),
      ]
    };
  }

  public getButtonsForPanel(panelId: string) {
    return this.userButtonMap[panelId];
  }

  // this method sets the visible and enabled flags for the buttons based on the display mode
  public initializeDetailPageButtons(cellDataMap: any) {
    if (this.dataService.displayMode === 'C') {
      this.rebuildButtonArray(this.userButtonMap['detail-main'],
        [
          'Save'
        ]);
      this.rebuildButtonArray(this.userButtonMap['detail-table'],
        [
          'Delete_Main',
          'Add Row'
        ]);
    } else if (this.dataService.displayMode === 'V') {
      this.rebuildButtonArray(this.userButtonMap['detail-main'],
        [
          'Edit',
          'Delete'
        ]);

      this.rebuildButtonArray(this.userButtonMap['detail-table'],
        [
          'Delete_Main'
        ]);
    } else {
      this.rebuildButtonArray(this.userButtonMap['detail-main'],
        [
          'Save',
          'Delete',
        ]);
      this.enableAllButtons(this.userButtonMap['detail-table']);
    }
  }

  public performButtonActions(action: any) {
    switch (action) {
      case 'Save': {
        /* in the scenario of saving header with details we are not getting primaryid value
        [reportId] from backend after save, need to store the value before save for navigation */
        const primaryIdValue = this.dataService.primaryDataMap['reportId'].cVal;
        this.dataService.setPrimarySelectedDocument(primaryIdValue);
        this.actionService.successMsg = this.resourceService.get('msg_save_succ');
        const saveObs = this.actionService.savePage();
          if (saveObs) {
            saveObs.subscribe((response) => {
              if (response.statusCode === 200) {
                // Clear edit flags
                this.dataService.detailsSearchService.clearMarkerFlags();
                this.actionService.clearEditedFlags();
                this.navService.preventNavigation = false;
                const successMsg = 'msg_save_succ';
                this.alertService.clearAll().success(this.resourceService.get(successMsg));
                if (this.dataService.displayMode === 'C') {
                  // Setting Search Criteria in Details Search Service which is the input for Data Table in Details Accordion
                  if (this.dataService.displayMode === 'C') {
                    this.dataService.getDetailsSearchService().setSearchCriteria({
                      conditions: [{
                        mandatory: false,
                        clauses: [{
                          column: this.dataService.primarySearchParams.idProperty,
                          operation: '=',
                          value: this.dataService.getPrimarySelectedDocument(),
                          logicalOperation: null
                        }],
                        logicalOperation: null
                      }]
                    });
                  }
                }
                if (this.dataService.displayMode === 'E' || this.dataService.displayMode === 'C') {
                  this.dataService.setDisplayMode('V');
                  this.initializeDetailPageButtons(this.dataService.primaryDataMap);
                  // If there are line items in details page
                  if (this.dataService.entityConfig.getShowDetailLineItems()) {
                    this.dataService.getDetailsSearchService().performSearch();
                  }
                }
              } else {
                this.alertService.clearAll().error(this.resourceService.get(response.error));
              }
            }, (error) => {
              this.alertService.clearAll().error(this.resourceService.get(error));
            });
          }
        break;
      }
      case 'Duplicate': {
        this.actionService.successMsg = this.resourceService.get('msg_dup_itm_succ');
        this.actionService.errorMsg = this.resourceService.get('msg_sel_itm');
        this.actionService.duplicateRow();
        break;
      }
      default : {
        super.performButtonActions(action);
      }
    }
  }
}



// WEBPACK FOOTER //
// /home/runner/work/fbm-fulfillment-wms-client/fbm-fulfillment-wms-client/src/app/features/reports/reports-configuration/services/reports-configuration-button.service.ts